import { initRequestInterceptors } from '@tencent/wphk-components-project-common';
import { RequestConfig, login } from '@tencent/wphk-act-base-api';
import { appidJsapiSign } from '@tencent/wphk-act-base-cgi';
import { cacheFunc, to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { wxBridge } from '@tencent/wphk-base-wx';
import { LoginReport } from '@tencent/wphk-base-report';

const cacheAppidJsapiSign = cacheFunc(appidJsapiSign);
let loginInitDone = false;
let loginActive = false;

// 自动检测登陆态、并实现自动登陆，同时拦截登陆超时后的请求
initRequestInterceptors({
  sessionOut: {
    beforeLogin(params) {
      const { isLoggedIn } = params;
      if (!isLoggedIn) {
        try {
          const loginReport = new LoginReport(process.env.VUE_APP_PKGNAME);
          loginReport.reportStartTiming(window.__$$_pageStartTime);
        } catch (error) {
        }
      }
    },
    login() {
      // 进行微信Auth登陆
      login.login({ scope: false, domain: RequestConfig.WX_LOGIN_DOMAIN, force: true });
    },
  },
});

/**
 * 登录检查
 */
export async function checkLogin() {
  const res = await cacheAppidJsapiSign({
    url: location.href.split('#')[0],
    appName: 'hk_life',
  });
  const { appId, nonceStr, signature, timestamp } = res;
  return {
    appId,
    nonceStr,
    signature,
    timestamp,
  };
}

/**
 * 登录初始化
 */
export async function loginInit() {
  if (loginInitDone) return;
  if (loginActive) return;
  loginActive = true;
  const [err, res] = await to(checkLogin());
  if (err) {
    new CustomException(err, 'checkLoginFail', '检查登录接口报错');
  }
  loginActive = false;
  if (res) {
    loginInitDone = true;
    wxBridge.weiXinInit({
      openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'],
      // 获取 ticket 的方法，需要为promise，可以从模版页获取或请求接口获取
      getTicket: () => Promise.resolve(res),
    });
  }
}
